import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IFilterSection) {
    (function(SelectionType) {
        SelectionType["SELECTION_TYPE_UNKNOWN"] = "SELECTION_TYPE_UNKNOWN";
        SelectionType["SINGLE"] = "SINGLE";
        SelectionType["MULTIPLE"] = "MULTIPLE";
        SelectionType["SINGLE_REQUIRED"] = "SINGLE_REQUIRED";
        SelectionType["MULTIPLE_SELECTION_OR_SINGLE_RANGE"] = "MULTIPLE_SELECTION_OR_SINGLE_RANGE";
        SelectionType["TOGGLE"] = "TOGGLE";
        SelectionType["MULTIPLE_OPTIONAL_SELECTIONS"] = "MULTIPLE_OPTIONAL_SELECTIONS";
        SelectionType["NAVIGATION"] = "NAVIGATION";
    })(IFilterSection.SelectionType || (IFilterSection.SelectionType = {}));
    (function(FieldName) {
        FieldName["FIELD_NAME_UNKNOWN"] = "FIELD_NAME_UNKNOWN";
        FieldName["CATEGORY"] = "CATEGORY";
        FieldName["WHOLESALE_PRICE"] = "WHOLESALE_PRICE";
        FieldName["MAKER_MINIMUM"] = "MAKER_MINIMUM";
        FieldName["MAKER_VALUE"] = "MAKER_VALUE";
        FieldName["BRAND"] = "BRAND";
        FieldName["INSIDER"] = "INSIDER";
        FieldName["LOCATION"] = "LOCATION";
        FieldName["MAKER_SPECIAL"] = "MAKER_SPECIAL";
        FieldName["LEAD_TIME"] = "LEAD_TIME";
        FieldName["SHIPS_FROM"] = "SHIPS_FROM";
        FieldName["SORTING"] = "SORTING";
        FieldName["CLEARANCE"] = "CLEARANCE";
        FieldName["COLLECTION_PRICE"] = "COLLECTION_PRICE";
        FieldName["RETAIL_PRICE"] = "RETAIL_PRICE";
        FieldName["DELIVERY_METHOD"] = "DELIVERY_METHOD";
        FieldName["PRODUCT_ATTRIBUTE"] = "PRODUCT_ATTRIBUTE";
        FieldName["RETAILER_TYPE"] = "RETAILER_TYPE";
        FieldName["PROXIMITY"] = "PROXIMITY";
        /**
     * used by ConsumerBestseller filters
     */ FieldName["FOR_PERIOD"] = "FOR_PERIOD";
        /**
     * used by ConsumerBestseller filters
     */ FieldName["BREAKDOWN"] = "BREAKDOWN";
        /**
     * used by ConsumerBestseller filters
     */ FieldName["BESTSELLER_CATEGORY"] = "BESTSELLER_CATEGORY";
        /**
     * used by ConsumerBestseller filters
     */ FieldName["STORE_TYPE"] = "STORE_TYPE";
        /**
     * used by ConsumerBestseller filters
     */ FieldName["BESTSELLER_MAKER_VALUE"] = "BESTSELLER_MAKER_VALUE";
        /**
     * used by ConsumerBestseller filters
     */ FieldName["BESTSELLER_REGION"] = "BESTSELLER_REGION";
        /**
     * Flash sale discount filter
     */ FieldName["DISCOUNT_PERCENTAGE"] = "DISCOUNT_PERCENTAGE";
        /**
     * Immediate vs. preorder filter
     */ FieldName["DELIVERY_WINDOW"] = "DELIVERY_WINDOW";
        /**
     * hack week 2020 - Eco filters remove after 2021-01-01
     * @deprecated
     */ FieldName["BRAND_CERTIFICATIONS"] = "BRAND_CERTIFICATIONS";
        /**
     * Used by preorder marketplace
     */ FieldName["PREORDER_WINDOW"] = "PREORDER_WINDOW";
        /**
     * Used by 2021 Faire Fashion Week
     * @deprecated
     */ FieldName["FAIRE_FASHION_WEEK"] = "FAIRE_FASHION_WEEK";
        FieldName["TOP_SHOP"] = "TOP_SHOP";
        FieldName["MID_PRICE_POINT_PLUS"] = "MID_PRICE_POINT_PLUS";
        FieldName["ON_MARKET_LIST"] = "ON_MARKET_LIST";
        /**
     * only used for FFW
     * @deprecated
     */ FieldName["ADDED_TO_CART"] = "ADDED_TO_CART";
        FieldName["PREVIOUSLY_ORDERED"] = "PREVIOUSLY_ORDERED";
        /**
     * only used for FFW
     * @deprecated
     */ FieldName["FFW_NEVER_ORDERED_DISCOUNT"] = "FFW_NEVER_ORDERED_DISCOUNT";
        FieldName["SHOP_BASED_IN_COUNTRY"] = "SHOP_BASED_IN_COUNTRY";
        FieldName["BRAND_NEW_PRODUCTS"] = "BRAND_NEW_PRODUCTS";
        FieldName["BASED_IN"] = "BASED_IN";
        FieldName["MADE_IN"] = "MADE_IN";
        FieldName["BRAND_PROMOTION"] = "BRAND_PROMOTION";
        FieldName["MARKET_LIST"] = "MARKET_LIST";
        FieldName["EUROPEAN_LOCATION"] = "EUROPEAN_LOCATION";
        FieldName["SHIP_WINDOW"] = "SHIP_WINDOW";
        /**
     * only used for FFW
     * @deprecated
     */ FieldName["FFW_PREVIOUSLY_ORDERED"] = "FFW_PREVIOUSLY_ORDERED";
        /**
     * @deprecated
     */ FieldName["FAIRE_SPECIALS"] = "FAIRE_SPECIALS";
        FieldName["USER"] = "USER";
        FieldName["NEW_PRODUCTS"] = "NEW_PRODUCTS";
        FieldName["TAXONOMY_TYPE"] = "TAXONOMY_TYPE";
        FieldName["CART_SUBMITTED_FOR_REVIEW"] = "CART_SUBMITTED_FOR_REVIEW";
        FieldName["FAIRE_PROTECTION"] = "FAIRE_PROTECTION";
        FieldName["BRAND_PROMOTION_TOGGLE"] = "BRAND_PROMOTION_TOGGLE";
        FieldName["LOW_MINIMUM"] = "LOW_MINIMUM";
        /**
     * @deprecated
     */ FieldName["MARKUP"] = "MARKUP";
        /**
     * Provides granular locations within countries
     */ FieldName["FAIRE_DETERMINED_LOCATION"] = "FAIRE_DETERMINED_LOCATION";
        FieldName["BRAND_SAMPLES"] = "BRAND_SAMPLES";
        /**
     * Used by Orders page filters
     */ FieldName["ORDER_DATE"] = "ORDER_DATE";
        /**
     * Used by orders page filters
     */ FieldName["ORDER_STATUS"] = "ORDER_STATUS";
        /**
     * Used by Eco-friendly product attributes filter
     */ FieldName["ECO_FRIENDLY_PRODUCT_ATTRIBUTES"] = "ECO_FRIENDLY_PRODUCT_ATTRIBUTES";
        /**
     * Used by Eco-friendly product attribute value quick filter
     */ FieldName["ECO_FRIENDLY_PRODUCT_ATTRIBUTE_VALUES"] = "ECO_FRIENDLY_PRODUCT_ATTRIBUTE_VALUES";
        FieldName["EXCLUSIVITY"] = "EXCLUSIVITY";
        /**
     * only used for new brands/new arrivals free shipping
     */ FieldName["NEW_ARRIVALS_FREE_SHIPPING"] = "NEW_ARRIVALS_FREE_SHIPPING";
        /**
     * @deprecated
     */ FieldName["TRENDING"] = "TRENDING";
        /**
     * Used by Orders page filtering by store.
     */ FieldName["RETAILER_STORE"] = "RETAILER_STORE";
        /**
     * Used to surface top leaf category pills as toggles.
     */ FieldName["TOP_CATEGORY_PILLS"] = "TOP_CATEGORY_PILLS";
        /**
     * Used to surface leaf categories as toggles.
     */ FieldName["CATEGORIES_FOR_YOU"] = "CATEGORIES_FOR_YOU";
        /**
     * Filters products that have at least one option with a GTIN
     */ FieldName["GLOBAL_TRADE_ITEM_NUMBER"] = "GLOBAL_TRADE_ITEM_NUMBER";
        /**
     * Filters products that is considered new to the retailer
     */ FieldName["NEW_TO_YOU"] = "NEW_TO_YOU";
    })(IFilterSection.FieldName || (IFilterSection.FieldName = {}));
    (function(FieldFunction) {
        FieldFunction["FIELD_FUNCTION_UNKNOWN"] = "FIELD_FUNCTION_UNKNOWN";
        FieldFunction["FILTER"] = "FILTER";
        FieldFunction["SORT"] = "SORT";
    })(IFilterSection.FieldFunction || (IFilterSection.FieldFunction = {}));
    (function(IFilterBanner) {
        IFilterBanner.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IFilterSection.IFilterBanner || (IFilterSection.IFilterBanner = {}));
    (function(IFilterTooltip) {
        IFilterTooltip.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IFilterSection.IFilterTooltip || (IFilterSection.IFilterTooltip = {}));
    (function(BadgeType) {
        BadgeType["BADGE_TYPE_UNKNOWN"] = "BADGE_TYPE_UNKNOWN";
        BadgeType["NEW_BADGE"] = "NEW_BADGE";
    })(IFilterSection.BadgeType || (IFilterSection.BadgeType = {}));
    (function(IFilterBadge) {
        IFilterBadge.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IFilterSection.IFilterBadge || (IFilterSection.IFilterBadge = {}));
    IFilterSection.build = function(partial) {
        return _object_spread({
            options: [],
            range_filters: [],
            option_groups: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IFilterSection || (IFilterSection = {}));
export var IFilterSection;
